import { useState } from "react";

export const PopUp = () => {
  const [visible, setVisible] = useState(true);

  const handleClickPopUp = () => {
    setTimeout(() => {
      setVisible(false);
    }, 3000);
  };

  return (
    <div
      onClick={handleClickPopUp}
      className={`absolute top-0 left-0 w-screen h-screen bg-[#256DB8] ${
        visible ? "" : "hidden"
      }`}
    >
      <div className="flex flex-col items-center justify-center gap-y-8">
        <div className="flex flex-col text-center text-shadow-xl text-[74px] font-bold text-[#FAD200] leading-[80px]">
          <p>TOP SCORE = TOP PRIZE</p>
          <p>5 STAR PHILIPPINES RESORT</p>
          <p>WINNER ANNOUNCED DECEMBER 25</p>
        </div>
        <img
          className="object-cover max-w-[900px] shadow-md border-[#FAD200] border-2"
          src="/images/beach.jpeg"
          alt=""
        />
      </div>
    </div>
  );
};
